import { render } from "./ReviewsHero.vue?vue&type=template&id=b767acb8&scoped=true"
import script from "./ReviewsHero.vue?vue&type=script&lang=js"
export * from "./ReviewsHero.vue?vue&type=script&lang=js"

import "./ReviewsHero.vue?vue&type=style&index=0&id=b767acb8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b767acb8"]])

export default __exports__